import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    steps: [
      {
        step: 'anamnesis',
        name: 'Анамнез'
      },
      {
        step: 'clarification',
        name: 'Уточнение анамнеза'
      },
      {
        step: 'syndromes',
        name: 'Синдромы'
      },
      {
        step: 'examination',
        name: 'Обследования'
      },
      {
        step: 'diagnosis',
        name: 'Диагноз'
      },
      {
        step: 'treatment',
        name: 'Лечение'
      },
      {
        step: 'repeated',
        name: 'Повторный прием'
      }
    ]
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
